import DeleteIcon from "@mui/icons-material/Delete";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import { Button, Grid } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from "@mui/x-data-grid";
import { FormEvent, useMemo, useState } from "react";
import DataTable from "../../../common/components/dataTable";
import ErrorBadge from "../../../common/components/forms/errorBadge";
import FormHeader from "../../../common/components/forms/formHeader";
import SelectStyled from "../../../common/components/input/selectStyled";
import TextFieldStyled from "../../../common/components/input/textFieldStyled";
import LoadingIndicator from "../../../common/components/loadingIndicator";
import { useUnidadeNegocioGuard } from "../../../common/hooks/useUnidadeNegocioGuard";
import PageLayout from "../../../common/layouts/pageLayout";

import {
  useCorrespondenciasRolex,
  useCorrespondenciaDetalhesRolex,
  useCreateCorrespondenciaDetalheRolex,
  useDeleteCorrespondenciaDetalheRolex,
} from "./rolex.hooks";

import { useParams } from "react-router";

const ROLEX_CORRELATION_TYPES = [
  "Cód. Produto",
  "Mov. importação no sistema",
  "Centro de Custo",
  "Local de estoque",
  "Cód. Transportadora",
  "Identificador da natureza",
  "Identificador da natureza 2",
  "Cód. Identificador natureza",
  "Cód. Local de estoque",
  "Cfop",
  "CST",
  "Pis/Cofins"
]

const RolexCorrespondenciaDetailsPage = () => {
  useUnidadeNegocioGuard();

  const { id: correspondenciaCatalogoId } = useParams<{ id: string }>();

  const [listaPai] = useCorrespondenciasRolex();
  const [detalhes, isDetalhesLoading] = useCorrespondenciaDetalhesRolex(correspondenciaCatalogoId);
  const [createDetalhe, isCreating, hasCreateError] = useCreateCorrespondenciaDetalheRolex();
  const [deleteDetalhe, isDeleting, hasDeleteError] = useDeleteCorrespondenciaDetalheRolex();

  const [tipoCorrespondencia, setTipoCorrespondencia] = useState<string>();
  const [codigoTxt, setCodigoTxt] = useState<string>();
  const [error, setError] = useState<string>();

  const produtoPai = useMemo(() => {
    return listaPai?.find((item: any) => item.id == correspondenciaCatalogoId);
  }, [listaPai, correspondenciaCatalogoId]);

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: "tipo",
        headerName: "Tipo",
        flex: 1,
        headerClassName: "header-theme",
      },
      {
        field: "codigoTxt",
        headerName: "Código no TXT",
        flex: 1,
        headerClassName: "header-theme",
        type: "string",
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Ações",
        headerClassName: "header-theme",
        getActions: (params: GridRowParams) => [
          <GridActionsCellItem
            placeholder=""
            icon={<DeleteIcon />}
            label="Deletar"
            color="error"
            onClick={() => {
              deleteDetalhe({ id: params.id as string });
            }}
          />,
        ],
      },
    ],
    [deleteDetalhe]
  );

  const rows = useMemo(() => {
    return (detalhes ?? []).map((item: any) => ({
      id: item.id,
      tipo: item.tipo,
      codigoTxt: item.codigoTxt,
    }));
  }, [detalhes]);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const exists = detalhes?.find((item: any) => item.tipo === tipoCorrespondencia);

    if (exists) {
      setError("Já existe uma correspondência configurada para este item.");
      return;
    }

    setError("");

    createDetalhe({
      requestPayload: {
        correspondenciaCatalogoId: correspondenciaCatalogoId,
        tipo: tipoCorrespondencia,
        codigoTxt: codigoTxt,
        quickcomexId: "0",
        nome: tipoCorrespondencia,
      },
    });

    if (!isCreating) {
      setTipoCorrespondencia("");
      setCodigoTxt("");
    }
  };

  return (
    <PageLayout
      title={"Correspondencia de Integração - TXT"}
      icon={<HistoryEduIcon color={"secondary"} />}
    >
      {isDetalhesLoading ? (
        <LoadingIndicator />
      ) : (
        <Grid container spacing={2}>
          <FormHeader marginTop="0">
            {produtoPai
              ? `Configurações para: ${produtoPai.material} - ${produtoPai.descricao}`
              : "Detalhes"}
          </FormHeader>

          <Grid item sm={12}>
            <DataTable
              columns={columns}
              rows={rows}
            ></DataTable>
          </Grid>

          <Grid item sm={12}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <FormHeader marginTop="0">Adicionar Regra</FormHeader>

                <Grid item sm={12}>
                  <SelectStyled
                    options={ROLEX_CORRELATION_TYPES.map((val, i) => ({ id: i, value: val }))}
                    label={"Tipo de Dado"}
                    onChangeAction={(e, value) => setTipoCorrespondencia(value?.value || "")}
                  // value={tipoCorrespondencia}
                  />
                </Grid>

                <Grid item sm={12}>
                  <TextFieldStyled
                    value={codigoTxt || ""}
                    required
                    label={`Código p/ o TXT (${tipoCorrespondencia || "..."})`}
                    onChange={(e) => setCodigoTxt(e.target.value)}
                  ></TextFieldStyled>
                </Grid>

                <Grid item sm={12} textAlign="right">
                  <Button
                    disabled={!tipoCorrespondencia || !codigoTxt || isCreating}
                    type="submit"
                    variant="contained"
                    color="secondary"
                  >
                    {isCreating ? "Salvando..." : "Salvar Regra"}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
          {error && <ErrorBadge error={error} />}
        </Grid>
      )}
    </PageLayout>
  );
};

export default RolexCorrespondenciaDetailsPage;